import { useQuery } from '@tanstack/react-query';
import {
  type ProfileModuleDto,
  type ProfileTemplate,
  ProfileTemplatesApi,
} from '@up2stay/up2promo-api-client';

import { parseFieldPolicies } from '@/core/lib/profile-template-fields';
import { useCurrentWorkspace } from '@/core/store/workspace.store';

export function useProfileTemplate(templateId: string | null | undefined) {
  const workspace = useCurrentWorkspace();

  const query = useQuery({
    queryKey: ['profile-template', workspace?.id, templateId],
    queryFn: async (): Promise<ProfileTemplate | null> => {
      if (!workspace?.id || !templateId) return null;
      const res = await ProfileTemplatesApi.findOne({
        path: { workspaceId: workspace.id, templateId },
      });
      return res.data ?? null;
    },
    enabled: Boolean(workspace?.id && templateId),
    staleTime: 60 * 1000,
  });

  const template = query.data ?? null;
  const fieldPolicies = parseFieldPolicies(
    template &&
      'fieldPolicies' in template &&
      (template as { fieldPolicies?: unknown }).fieldPolicies,
  );
  const templateModules = (template?.content?.modules ??
    []) as unknown as ProfileModuleDto[];

  return {
    template,
    fieldPolicies,
    templateModules,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
